import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

type ExportFormat = 'xlsx' | 'csv' | 'pdf';

export async function exportReport(data: any[], filename: string, format: ExportFormat = 'xlsx') {
  try {
    if (format === 'xlsx' || format === 'csv') {
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Report');
      
      const excelBuffer = XLSX.write(wb, { bookType: format, type: 'array' });
      const blob = new Blob([excelBuffer], { 
        type: format === 'xlsx' 
          ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
          : 'text/csv'
      });
      
      saveAs(blob, `${filename}.${format}`);
    } else if (format === 'pdf') {
      // TODO: Implementar exportação PDF quando necessário
      throw new Error('Exportação para PDF ainda não implementada');
    }
  } catch (error) {
    console.error('Erro ao exportar relatório:', error);
    throw error;
  }
}